import React from 'react';

import VideocamOffOutlinedIcon from '@material-ui/icons/VideocamOffOutlined';
import useStyles from './styles';
import Switch from '@material-ui/core/Switch';

const VideoSettings = React.memo(({ hasVideo, onVideoChange }) => {
  const classes = useStyles();
  
  return (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
        <VideocamOffOutlinedIcon className={classes.icon}/>
        <div className={classes.copy}>Video</div>
      </div>
      <Switch checked={hasVideo} color="default" onChange={onVideoChange} name="VideoToggle" qaid="video-toggle-switch"/>
    </div>
  );
});

export default VideoSettings;
